var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useId } from '../hooks';
import Label from './label';
import Steps from './steps';
import { progressStyle, progressWrapperStaticStyle, wrapperStyle, } from './styles';
function Progress(_a) {
    var ariaLabel = _a["aria-label"], customLabel = _a.customLabel, _b = _a.hideLabel, hideLabel = _b === void 0 ? false : _b, _c = _a.inverted, inverted = _c === void 0 ? false : _c, _d = _a.max, max = _d === void 0 ? 100 : _d, _e = _a.mode, mode = _e === void 0 ? 'continuous' : _e, _f = _a.size, size = _f === void 0 ? 'medium' : _f, _g = _a.value, value = _g === void 0 ? 0 : _g, _h = _a.variant, variant = _h === void 0 ? 'default' : _h, restProps = __rest(_a, ['aria-label', "customLabel", "hideLabel", "inverted", "max", "mode", "size", "value", "variant"]);
    var progressId = "progress-".concat(useId());
    var isStepsMode = mode === 'steps';
    return (_jsxs("div", __assign({ css: wrapperStyle({ inverted: inverted, size: size }), "data-testid": "progress-wrapper" }, { children: [_jsxs("div", __assign({ css: progressWrapperStaticStyle }, { children: [isStepsMode && _jsx(Steps, { id: progressId, max: max, size: size }), _jsx("progress", __assign({ "aria-label": isStepsMode
                            ? ariaLabel.concat(' ', "".concat(Math.floor(value), " out of ").concat(max, " steps"))
                            : ariaLabel, "aria-valuemax": max, "aria-valuemin": 0, "aria-valuenow": value, css: progressStyle({
                            clipId: "".concat(progressId, "-clip"),
                            size: size,
                            variant: variant,
                        }), id: progressId, max: max, value: value }, restProps))] })), !hideLabel && (_jsx(Label, __assign({}, { customLabel: customLabel, id: progressId, isStepsMode: isStepsMode, max: max, value: value })))] })));
}
export default Progress;
